import { Link } from 'react-router-dom';

export default function MainChaptersList(props) {
  return (
    <Link to={props.link}>
      <div className="flex items-end rounded-lg hover:bg-neutral-200 dark:hover:bg-neutral-800 group px-4 py-2 my-2">
        <h3 className="text-neutral-600 dark:text-neutral-400 whitespace-nowrap">{props.index}</h3>
        <h4 className="ml-2 text-xl group-hover:underline truncate">{props.name}</h4>
      </div>
    </Link>
  )
}